<template>
	<div id="pay_wrap" v-if="$store.state.isShowPay" @click="hidePay">
		<div class="pay_body_wrap" @click.stop>
			<div class="pay_body_title_wrap">
				<a href="javascript:;" class="pay_close_button" @click="hidePay">
					<img :src="require('../assets/icon_close_white.png')" />
				</a>
				<div
					:class="{
                    'pay_body_title_item':true,
					'pay_body_title_left_item':true,
					'active': $store.state.payType==='down'?true:false}"
					@click="changeTitleItem('down')"
				>下行提速</div>
				<div
					:class="{
					'pay_body_title_item':true,
                    'pay_body_title_right_item':true,
					'active': $store.state.payType==='up'?true:false}"
					@click="changeTitleItem('up')"
				>上行提速</div>
				<div
					class="pay_body_title_item"
					v-if="!$store.state.isSupportDown || !$store.state.isSupportUp"
				>&nbsp;</div>
			</div>
			<div v-show="!isShowSuccess && $store.state.payType==='down'">
				<div class="pay_body_device_tips" v-if="false && $store.state.sys.cid == 106">
					<p>尊敬的极路由用户您好</p>
					<p class="second">向您推荐限时特惠</p>
				</div>
				<div class="pay_body_sub_title_wrap">开通时长</div>
				<div class="pay_body_select_wrap">
					<a
						href="javascript:;"
						:class="{'pay_body_select_item_wrap':true,'active':payGoodsDown.gid==goods.gid?true:false}"
						@click="changePayGoodsIdDown(goods.gid)"
						:key="goods.gid"
						v-for="goods in $store.state.goodsDown"
					>
						<div class="pay_body_select_item_discount_icon" v-if="goods.gsellprice > 3500">限时特惠</div>
						<div class="pay_body_select_item_thanks_icon" v-else-if="goods.gsellprice > 2000">新用户首月</div>
						<div class="pay_body_select_item_discount_icon" v-else-if="goods.gsellprice > 1000">限时特惠</div>
						<div class="pay_body_select_item_thanks_icon" v-else>新用户首月</div>

						<div class="pay_body_select_item_type">{{goods.gname}}</div>
						<div class="pay_body_select_item_sell_price">
							<span>￥</span>
							<font>{{(goods.gsellprice/100).toFixed(2)}}</font>
						</div>
						<div class="pay_body_select_item_price">
							<span>￥</span>
							<font>{{(goods.gprice/100).toFixed(2)}}</font>
						</div>
						<div class="pay_body_select_item_desc">{{goods.gdesc}}</div>
					</a>
				</div>
				<div
					class="pay_bjlt_tips"
					v-if="$store.state.province == '北京' && $store.state.isp == '联通'"
				>提醒：您的宽带不支持同时使用上行、下行两种提速</div>
				<div
					class="qrcode_pay_wrap"
					v-if="!($store.state.province == '北京' && $store.state.isp == '联通' && $store.state.isPayUp)"
				>
					<canvas width="145" height="145" id="qrcode_down" class="qrcode"></canvas>
					<div class="pay_info">
						<div>微信扫码支付</div>
						<div>
							应付金额
							<font>￥</font>
							<span>{{payGoodsDown.gsellprice>0?(payGoodsDown.gsellprice/100).toFixed(2):0}}</span>
						</div>
					</div>
				</div>
			</div>
			<div v-show="!isShowSuccess && $store.state.payType==='up'">
				<div class="pay_body_device_tips" v-if="false && $store.state.sys.cid == 106">
					<p>尊敬的极路由用户您好</p>
					<p class="second">向您推荐限时特惠</p>
				</div>
				<div class="pay_body_sub_title_wrap">开通时长</div>
				<div class="pay_body_select_wrap">
					<a
						href="javascript:;"
						:class="{'pay_body_select_item_wrap':true,'active':payGoodsUp.gid==goods.gid?true:false}"
						@click="changePayGoodsIdUp(goods.gid)"
						:key="goods.gid"
						v-for="goods in $store.state.goodsUp"
					>
						<div class="pay_body_select_item_discount_icon" v-if="goods.gsellprice > 1">限时特惠</div>
						<div class="pay_body_select_item_thanks_icon" v-else>感恩回馈</div>
						<div class="pay_body_select_item_type">{{goods.gname}}</div>
						<div class="pay_body_select_item_sell_price">
							<span>￥</span>
							<font>{{(goods.gsellprice/100).toFixed(2)}}</font>
						</div>
						<div class="pay_body_select_item_price">
							<span>￥</span>
							<font>{{(goods.gprice/100).toFixed(2)}}</font>
						</div>
						<div class="pay_body_select_item_desc">{{goods.gdesc}}</div>
					</a>
				</div>
				<div
					class="pay_bjlt_tips"
					v-if="$store.state.province == '北京' && $store.state.isp == '联通'"
				>提醒：您的宽带不支持同时使用上行、下行两种提速</div>
				<div
					class="qrcode_pay_wrap"
					v-if="!($store.state.province == '北京' && $store.state.isp == '联通' && $store.state.isPayDown)"
				>
					<canvas width="145" height="145" id="qrcode_up" class="qrcode"></canvas>
					<div class="pay_info">
						<div>微信扫码支付</div>
						<div>
							应付金额
							<font>￥</font>
							<span>{{payGoodsUp.gsellprice>0?(payGoodsUp.gsellprice/100).toFixed(2):0}}</span>
						</div>
					</div>
				</div>
			</div>
			<div class="success_wrap" v-if="isShowSuccess">
				<div>
					<p>
						<img :src="successIcon" />
					</p>
					<p v-if="$store.state.payType == 'down'">您的下行提速套餐已购买成功</p>
					<p v-else>您的上行提速套餐已购买成功</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import QRCode from "qrcode";
import { mapActions } from "vuex";

export default {
	name: "Pay",
	data: function() {
		return {
			successIcon: require("../assets/success_icon.png"),
			isShowSuccess: false,
			paySuccessType: this.$store.state.payType,
			checkPayUpIntval: null,
			checkPayDownIntval: null,
			payGoodsDown: {},
			payGoodsUp: {},
			signData: {},
			outTradeNOUp: "",
			outTradeNODown: ""
		};
	},
	props: [],
	computed: {
		title: function() {
			return this.$store.state.payType == "up"
				? "上行提速支付"
				: "下行提速支付";
		}
	},
	methods: {
		...mapActions([
			"getGoodsList",
			"getPaySign",
			"getPayCheck",
			"sendUserlog"
		]),
		changeTitleItem: function(type) {
			let _that = this;
			if (
				(_that.$store.state.isSupportUp && type == "up") ||
				(_that.$store.state.isSupportDown && type == "down")
			) {
				_that.$store.state.payType = type;
			}

			// _that.getPay(type);
		},
		showSuccess: function() {
			this.isShowSuccess = true;
		},
		hidePay: function() {
			let _that = this;
			if (window.KDTS) {
				window.KDTS.isHandleBack(false);
			}
			_that.sendUserlog(["pay_back_btn_click", ""]);
			clearInterval(_that.checkPayUpIntval);
			clearInterval(_that.checkPayDownIntval);
			_that.$store.state.isShowPay = false;
		},
		getGoods: function(type) {
			let _that = this;
			let typeNum = type == "up" ? 1 : 2;
			this.getGoodsList([
				typeNum,
				function(err, data) {
					if (err) {
						_that.$toast("发送请求失败");
						return;
					}
					if (_that.$store.state.goods.length > 0) {
						if (type == "up") {
							_that.payGoodsUp = _that.$store.state.goodsUp[0];
						} else {
							_that.payGoodsDown =
								_that.$store.state.goodsDown[0];
						}
						_that.getPay(type);
					}
				}
			]);
		},
		changePayGoodsIdDown: function(gid) {
			// console.log(gid);
			let _that = this;
			_that.sendUserlog(["goods_btn_click", gid]);
			for (var i = 0; i < this.$store.state.goodsDown.length; i++) {
				let item = this.$store.state.goodsDown[i];
				if (item.gid == gid) {
					this.payGoodsDown = item;
					_that.getPay("down");
					break;
				}
			}
		},
		changePayGoodsIdUp: function(gid) {
			// console.log(gid);
			let _that = this;
			_that.sendUserlog(["goods_btn_click", gid]);
			for (var i = 0; i < this.$store.state.goodsUp.length; i++) {
				let item = this.$store.state.goodsUp[i];
				if (item.gid == gid) {
					this.payGoodsUp = item;
					_that.getPay("up");
					break;
				}
			}
		},
		getPay: function(type) {
			let _that = this;

			let payGoods = null;
			if (type == "down") {
				payGoods = _that.payGoodsDown;
			} else {
				payGoods = _that.payGoodsUp;
			}

			if (!payGoods) {
				return;
			}

			_that.sendUserlog(["pay_btn_click", payGoods.gid]);
			_that.$store.state.isShowLoading = true;

			this.getPaySign([
				payGoods.gid,
				function(err, data) {
					if (err) {
						_that.$toast("请求失败，请检查网络");
						_that.$store.state.isShowLoading = false;
						return;
					}
					if (data.rtn == 0) {
						_that.signData = data.data;
						// console.log(data.data.outTradeNO);
						if (type == "down") {
							_that.outTradeNODown = data.data.outTradeNO;
						} else {
							_that.outTradeNOUp = data.data.outTradeNO;
						}
						_that.renderQrcode(type, data.data.CodeURL);
					} else {
						_that.$toast("服务器错误，请重试");
						_that.$store.state.isShowLoading = false;
					}
				}
			]);
		},
		renderQrcode: function(type, url) {
			let _that = this;
			// console.log(type);
			let canvas = document.getElementById("qrcode_" + type);
			QRCode.toCanvas(canvas, url, { width: 145 }, function(error) {
				_that.$store.state.isShowLoading = false;
				if (error) {
					console.error(error);
					_that.$toast("生成支付二维码失败");
					return;
				}
				// console.log("QRCode success!");
				switch (type) {
					case "up":
						_that.startCheckPayUp();
						break;
					case "down":
						_that.startCheckPayDown();
						break;
					default:
						break;
				}
			});
		},
		startCheckPayUp: function() {
			let _that = this;
			// console.log(_that.outTradeNOUp);
			clearInterval(_that.checkPayUpIntval);
			_that.checkPayUpIntval = setInterval(function() {
				// console.log("_that.outTradeNOUp" + _that.outTradeNOUp);
				_that.checkPay("up", _that.outTradeNOUp);
			}, 5000);
		},
		startCheckPayDown: function() {
			let _that = this;
			// console.log(_that.outTradeNODown);
			clearInterval(_that.checkPayDownIntval);
			_that.checkPayDownIntval = setInterval(function() {
				// console.log("_that.outTradeNODown" + _that.outTradeNODown);
				_that.checkPay("down", _that.outTradeNODown);
			}, 5000);
		},
		checkPay: function(type, outTradeNO) {
			let _that = this;
			_that.getPayCheck([
				outTradeNO,
				function(err, data) {
					if (err) {
						// console.log(err);
						_that.$toast("发送请求失败，请检查网络");
						return;
					}
					if (data.data.trade_state == "SUCCESS") {
						// 通知支付完成，更新用户剩余时长
						_that.$store.state.isShowLoading = false;
						_that.showSuccess();
						_that.paySuccessType = type;

						setTimeout(function() {
							_that.hidePay();
							switch (type) {
								case "up":
									{
										_that.$emit("payUpEnd");
									}

									break;
								case "down":
									{
										_that.$emit("payDownEnd");
									}

									break;
								default:
									break;
							}
						}, 1000);
					}
				}
			]);
		}
	},
	mounted: function() {
		let _that = this;
		this.getGoods("up");
		this.getGoods("down");
		if (window.KDTS) {
			window.KDTS.isHandleBack(true);
		}
		window.handleBack = function() {
			_that.hidePay();
		};
	}
};
</script>

<style scoped lang="less">
#pay_wrap {
	width: 800px;
	height: 580px;
	position: absolute;
	bottom: 50px;
	left: 50%;
	margin-left: -400px;
	z-index: 99;
	overflow: hidden;
	background-color: #fff;

	.pay_body_device_tips {
		color: #a0775b;
		font-size: 42px;
		margin: 36px;
		text-align: center;

		.second {
			font-size: 36px;
		}
	}
}

@media screen and (max-width: 1000px) {
	#pay_wrap {
		width: 500px;
		margin-left: -250px;
		height: auto;
		bottom: 35px;

		.pay_body_title_wrap {
			height: 45px;
			line-height: 45px;
			font-size: 18px;
			.pay_body_title_item {
				width: 50%;
				height: 45px;
				line-height: 45px;
			}
		}
		.pay_close_button {
			width: 24px;
			height: 24px;
			left: 12px;
			top: 0px;
		}

		.pay_body_sub_title_wrap {
			font-size: 16px;
			margin: 15px 40px 15px 40px;
		}
		.pay_body_select_wrap {
			margin-left: 35px;
			margin-right: 35px;
		}
		.pay_body_select_item_wrap {
			width: 160px;
		}
		.qrcode_pay_wrap {
			zoom: 0.55;
			margin-bottom: 35px;
			// width: 80%;
			// .qrcode {
			// 	margin-left: 15px;
			// }
			// .pay_info {
			// 	font-size: 16px;
			// }
		}
	}
}

.pay_body_wrap {
	width: 100%;
}

.pay_body_title_wrap {
	font-size: 24px;
	color: #333;
	height: 65px;
	width: 100%;
	line-height: 65px;
	text-align: center;
	// border-bottom: 2px solid #eeeeee;
	background-color: #e4e4e4;
	/*no*/

	.pay_body_title_item {
		display: inline-block;
		width: 400px;
		height: 65px;
		line-height: 65px;
		margin-top: 0px;
		color: #666666;
		cursor: pointer;
	}
	.pay_body_title_left_item.active {
		border-top-right-radius: 10px;
		background-image: linear-gradient(to bottom, #f6d062, #c99c3d);
		color: #ffffff;
	}
	.pay_body_title_right_item.active {
		border-top-left-radius: 10px;
		background-image: linear-gradient(to bottom, #f6d062, #c99c3d);
		color: #ffffff;
	}
}

.pay_body_select_wrap {
	text-align: center;
	margin-left: 65px;
	margin-right: 65px;
}

.pay_body_select_wrap .active {
	background-color: #fefaf1;
	border: 1px solid #d3a746;
}

.pay_body_select_item_wrap {
	width: 200px;
	height: 140px;
	border: 1px solid #ccc;
	border-radius: 10px;
	text-align: center;
	display: inline-block;
	position: relative;
	margin-bottom: 30px;
	vertical-align: top;
	margin-left: 10px;
	margin-right: 10px;
	cursor: pointer;
}

.pay_body_select_item_type {
	font-size: 16px;
	color: #666666;
	padding-top: 10px;
}

.pay_body_select_wrap .active .pay_body_select_item_type {
	color: #666666;
}

.pay_body_select_item_discount_icon {
	position: absolute;
	right: -1px; /*no*/
	top: -20px;
	background: linear-gradient(135deg, #6b6b6b, #373737);
	color: #d9c9a8;
	font-size: 10px;
	padding: 6px 14px;
	border-top-right-radius: 12px;
	border-bottom-left-radius: 12px;
}

.pay_body_select_item_thanks_icon {
	position: absolute;
	right: -1px; /*no*/
	top: -20px;
	background: linear-gradient(135deg, #ff0000, #d41414);
	color: #ffffff;
	font-size: 12px;
	padding: 6px 14px;
	border-top-right-radius: 12px;
	border-bottom-left-radius: 12px;
}

.pay_body_select_item_sell_price {
	color: #666666;
	font-weight: bolder;
	margin: 5px auto;
	span {
		font-size: 14px;
		margin-right: 5px;
	}
	font {
		font-size: 28px;
	}
}

.pay_body_select_wrap .active .pay_body_select_item_sell_price {
	color: #cd9f40;
}

.pay_body_select_item_price {
	color: #666666;
	font-size: 12px;
	text-decoration: line-through;
}

.pay_body_select_item_desc {
	font-size: 12px;
	color: #666666;
	margin-top: 5px;
	height: 40px;
	line-height: 40px;
	border-top: 1px dashed #999999;
}

.pay_body_select_wrap .active .pay_body_select_item_desc {
	border-top: 1px dashed #d3a746;
	color: #666666;
}

.pay_body_sub_title_wrap {
	font-size: 18px;
	margin: 35px 80px 25px 80px;
	color: #666666;
}

.pay_price_wrap {
	margin-top: 30px;
	margin-left: 36px;
	font-size: 14px;
	color: #999999;

	font {
		font-size: 16px;
		color: #666666;
		margin-right: 5px;
	}

	span {
		font-size: 24px;
		color: #cd9f40;
		font-weight: bolder;
	}
}

.pay_price_desc {
	margin-left: 36px;
	font-size: 10px;
	color: #999999;
	margin-bottom: 50px;
	margin-top: 5px;

	font {
		color: #ffffff;
		font-size: 16px;
		margin-right: 10px;
	}

	img {
		vertical-align: sub;
		margin-left: 124px;
		margin-right: 10px;
		height: 24px;
		width: 24px;
	}
}

.pay_bjlt_tips {
	margin-left: 70px;
	color: red;
	margin-bottom: 20px;
	margin-top: -10px;
	font-size: 14px;
}

.pay_close_button {
	position: absolute;
	left: 16px;
	top: 10px;
	display: block;
	height: 40px;
	width: 40px;
	line-height: 40px;
	text-align: center;
	color: #bdbdbd;
	font-size: 40px;
}

.pay_close_button img {
	width: 70%;
	height: 70%;
	vertical-align: middle;
}

.pay_button {
	height: 120px;
	line-height: 120px;
	display: block;
	background: linear-gradient(to right, #ffebb1, #bea169);
	color: #5c4028;
	text-align: center;
	font-size: 34px;
	position: relative;
	overflow: hidden;
}

.pay_button:after {
	content: "";
	transform: rotate(45deg);
	position: absolute;
	top: -60px;
	left: -150px;
	height: 300px;
	width: 50px;
	background: linear-gradient(
		90deg,
		hsla(0, 0%, 100%, 0),
		hsla(0, 0%, 100%, 0.5),
		hsla(0, 0%, 100%, 0)
	);
	animation: btnlight 2s 2s linear infinite;
}

@keyframes btnlight {
	0% {
		transform: translate(0) rotate(45deg);
		transform-origin: 0 0;
	}

	100% {
		transform: translate(1050px) rotate(45deg);
		transform-origin: 0 0;
	}
}

.code_input_wrap {
	padding: 100px 0;
	text-align: center;
	font-size: 30px;
	color: #666;
	span {
		height: 80px;
		line-height: 80px;
		display: inline-block;
		vertical-align: top;
	}
	input {
		font-size: 40px;
		color: #666;
		height: 80px;
		line-height: 80px;
		width: 400px;
		border: 2px solid #cccccc;
		border-radius: 10px;
		vertical-align: top;
		padding: 0 30px;
		background: #ffffff;
	}
}

.qrcode_pay_wrap {
	width: 640px;
	height: 190px;
	border: 1px solid #cccccc;
	border-radius: 10px;
	margin: 0 auto;

	.qrcode {
		display: inline-block;
		vertical-align: top;
		background-color: #eeeeee;
		margin-left: 165px;
		margin-top: 25px;
	}

	.pay_info {
		display: inline-block;
		vertical-align: top;
		margin-top: 45px;
		margin-left: 20px;
		color: #333333;
		font-size: 18px;

		div {
			line-height: 50px;

			font {
				color: #e52323;
			}

			span {
				color: #e52323;
				font-size: 36px;
			}
		}
	}
}

.success_wrap {
	text-align: center;
	width: 640px;
	height: 170px;
	margin: 0 auto;
	border: 1px solid #d3a746;
	background-color: #fbf6ec;
	margin-top: 90px;
	color: #4ab218;
	font-size: 24px;
	padding-top: 70px;
	line-height: 40px;
}
</style>
